import React from 'react'
import PropTypes from 'prop-types'

const ChevronLeftCircle = ({ width = 39, height = width, fill = '#404040', color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 38 39"
      fill="none">
      <circle
        cx="19.0001"
        cy="19.3555"
        r="19"
        transform="rotate(-180 19.0001 19.3555)"
        fill={fill}
      />
      <path
        d="M23.5794 10.7297C23.8488 10.9693 24.0001 11.2944 24.0001 11.6332C24.0001 11.9721 23.8488 12.2972 23.5794 12.5368L16.4679 18.8632L23.5794 25.1895C23.8411 25.4306 23.9859 25.7534 23.9827 26.0885C23.9794 26.4236 23.8283 26.7442 23.5619 26.9811C23.2955 27.2181 22.9352 27.3525 22.5585 27.3554C22.1818 27.3583 21.8189 27.2295 21.548 26.9967L13.4207 19.7668C13.1514 19.5271 13.0001 19.2021 13.0001 18.8632C13.0001 18.5243 13.1514 18.1993 13.4207 17.9596L21.548 10.7297C21.8174 10.4901 22.1827 10.3555 22.5637 10.3555C22.9446 10.3555 23.31 10.4901 23.5794 10.7297Z"
        fill={color}
      />
    </svg>
  )
}

ChevronLeftCircle.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  color: PropTypes.string,
}

export default React.memo(ChevronLeftCircle)
